export let noSuggestionsToShowMessage = "dnDuPd";
export default {noSuggestionsToShowMessage};